export class ListKeyspacesBackupConfigsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "configs",
            "baseName": "configs",
            "type": "Array<KeyspacesBackupConfig>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListKeyspacesBackupConfigsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
